import { declareVueComponent } from '/vodalys/vvuejs/vueRegister.mjs'


declareVueComponent('visio2Attendees', () => import('./Visio2Attendees.vue'))